module.exports = "/images/select2.svg?1072590bfa66f71e2e88b989ef3a08f9";